export const SETTINGS_PAGE_PAYMENT_AND_PAYOUT_LINKS = [
    { label: 'Payments', href: '/settings/payments' }
];

// The tabs of Settings > Account
export const SETTINGS_PAGE_ACCOUNT_LINKS = [
    { label: 'General', href: '/settings' },
    { label: 'Notifications', href: '/settings/account/notifications' },
    { label: 'Plans & Billing', href: '/settings/account/billing' },
    { label: 'Audit Log', href: '/settings/account/audit-log' },
];